var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCarrier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0249 19L12.8999 20.875L16.9624 17.125",
    stroke: "#0095FF",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0125 1.5L5.48755 6.0375",
    stroke: "#0095FF",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9875 1.5L22.5125 6.0375",
    stroke: "#0095FF",
    strokeWidth: 2.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 8.8125C1.5 6.5 2.7375 6.3125 4.275 6.3125H23.725C25.2625 6.3125 26.5 6.5 26.5 8.8125C26.5 11.5 25.2625 11.3125 23.725 11.3125H4.275C2.7375 11.3125 1.5 11.5 1.5 8.8125Z",
    stroke: "#0095FF",
    strokeWidth: 2.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.375 11.5L5.1375 22.3C5.5375 24.725 6.5 26.5 10.075 26.5H17.6125C21.5 26.5 22.075 24.8 22.525 22.45L24.625 11.5",
    stroke: "#0095FF",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarrier);
export default __webpack_public_path__ + "static/media/iconCarrier.837e13c25562fa141098c3438013e752.svg";
export { ForwardRef as ReactComponent };